export default "<fusioncharts\r\n  type='doughnut2d'\r\n  width='100%'\r\n  [dataSource]='dataSource'>\r\n</fusioncharts>\r\n"